import { html as $, nothing as w } from '../../../../../node_modules/lit-html/lit-html.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';
import { renderProductPreviewCard } from './renderProductPreviewCard.js';

const renderMainCta = (viewportType, ctx) => {
    if (!ctx.mainCta)
        return w;
    const isRendered = viewportType === 'mobile' ? ctx.isMobile : !ctx.isMobile;
    if (!isRendered)
        return w;
    const { label, href, ariaLabel, target, emphasis, color } = ctx.mainCta;
    const rtlDir = ctx.rtl ? 'rtl' : 'ltr';
    return $ `<generic-button-updated type="${emphasis || 'primary'}" color="${color || 'purple'}" styleType="dark" appearance="default" label="${label}" href="${href}" target="${target || '_self'}" dir="${rtlDir}" .rtl="${ctx.rtl}" .ariaList="${{ 'aria-label': ariaLabel || label }}"></generic-button-updated>`;
};
const renderLayout = (ctx) => {
    const { cards, headline: headlineText, headlineId, rtl, query, handleMediaQuery } = ctx;
    const hasCards = cards && cards.length > 0;
    const totalCards = hasCards ? cards.length : 0;
    const direction = rtl ? 'rtl' : 'ltr';
    const headlineTemplate = headlineText
        ? $ `<h2 id="${headlineId}" class="headline">${o(headlineText)}</h2>`
        : w;
    const cardsTemplate = hasCards
        ? $ `<div class="swiper" dir="${direction}" role="group" aria-roledescription="carousel"><div class="swiper-wrapper">${cards.map((card, index) => renderProductPreviewCard(card, index, totalCards, rtl || false))}</div></div>`
        : $ `<div class="empty-state" role="status"><p>No products available</p></div>`;
    return $ `<div class="header">${headlineTemplate} ${renderMainCta('desktop', ctx)}</div>${cardsTemplate} ${renderMainCta('mobile', ctx)}<lit-media-query .query="${query}" @changed="${handleMediaQuery}"></lit-media-query>`;
};

export { renderLayout };
